import React from "react";
import * as S from "./styles";

const CompleteBox = ({
  completeTitle,
  completeText,
}: {
  completeTitle: string;
  completeText: string;
}) => (
  <S.Container>
    <S.Title>{completeTitle}</S.Title>
    <S.Complete dangerouslySetInnerHTML={{ __html: completeText }} />
  </S.Container>
);

export default CompleteBox;
